const contactSec = document.querySelector('.contact-sec');

if (contactSec) {
  const tabsWrap = contactSec.querySelector('.contact-sec__tabs');
  const tabs = Array.from(contactSec.querySelectorAll('.contact-sec__tab'));
  const forms = Array.from(contactSec.querySelectorAll('.contact-sec__form'));
  const formParam = new URLSearchParams(window.location.search).get('form');

  const updateIndicator = (tab) => {
    if (!tabsWrap || !tab) {
      return;
    }

    tabsWrap.style.setProperty('--contact-tab-indicator-x', `${tab.offsetLeft}px`);
    tabsWrap.style.setProperty('--contact-tab-indicator-w', `${tab.offsetWidth}px`);
  };

  const setActiveTab = (index) => {
    const nextTab = tabs[index];
    const nextForm = forms[index];

    if (!nextTab || !nextForm) {
      return;
    }

    tabs.forEach((item, itemIndex) => {
      const isActive = itemIndex === index;

      item.classList.toggle('is-active', isActive);
      item.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });

    forms.forEach((form, formIndex) => {
      form.classList.toggle('is-active', formIndex === index);
    });

    window.requestAnimationFrame(() => {
      updateIndicator(nextTab);
    });
  };

  const getTabIndexByForm = (formName) => {
    if (formName === 'clients') {
      const clientsIndex = tabs.findIndex((tab) => (
        tab.textContent.trim().toLowerCase() === 'clients'
      ));

      return clientsIndex >= 0 ? clientsIndex : 1;
    }

    return 0;
  };

  const openContactForm = (formName, { scroll = false, updateUrl = false } = {}) => {
    setActiveTab(getTabIndexByForm(formName));

    if (updateUrl) {
      const nextUrl = new URL(window.location.href);

      nextUrl.searchParams.set('form', formName);
      window.history.pushState({}, '', nextUrl.toString());
    }

    if (scroll) {
      if (typeof window.scrollToEl === 'function') {
        window.scrollToEl('#contact|800|50');
      } else {
        contactSec.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }
  };

  window.openContactForm = openContactForm;

  const activeTabIndex = formParam === 'clients'
    ? getTabIndexByForm('clients')
    : tabs.findIndex((tab) => tab.classList.contains('is-active'));

  setActiveTab(activeTabIndex >= 0 ? activeTabIndex : 0);

  if (formParam === 'clients') {
    window.requestAnimationFrame(() => {
      openContactForm('clients', { scroll: true });
    });
  }

  tabs.forEach((tab, index) => {
    tab.addEventListener('click', () => {
      setActiveTab(index);
    });
  });

  document.addEventListener('click', (event) => {
    if (
      event.defaultPrevented ||
      event.button !== 0 ||
      event.metaKey ||
      event.ctrlKey ||
      event.shiftKey ||
      event.altKey
    ) {
      return;
    }

    const link = event.target.closest('a[href]');

    if (!link || link.target === '_blank') {
      return;
    }

    const linkUrl = new URL(link.href, window.location.href);
    const isSamePage = linkUrl.origin === window.location.origin
      && linkUrl.pathname.replace(/\/$/, '') === window.location.pathname.replace(/\/$/, '');

    if (!isSamePage || linkUrl.searchParams.get('form') !== 'clients') {
      return;
    }

    event.preventDefault();
    openContactForm('clients', { scroll: true, updateUrl: true });
  });

  window.addEventListener('resize', () => {
    const currentTab = tabs.find((tab) => tab.classList.contains('is-active')) || tabs[0];

    updateIndicator(currentTab);
  });

  forms.forEach((form) => {
    const fileInput = form.querySelector('input[type="file"]');
    const uploadButtonText = form.querySelector('.contact-sec__upload .btn__text');

    if (!fileInput || !uploadButtonText) {
      return;
    }

    fileInput.addEventListener('change', () => {
      uploadButtonText.textContent = fileInput.files?.[0]?.name || 'Upload CV';
    });
  });

  const cvForm = document.getElementById('cv_upload_form');

  if (cvForm) {
    const reasonSelect = cvForm.querySelector('[name="reason"]');
    const cvHiddenInput = cvForm.querySelector('[name="cv_field"]');
    const cvFileInput = cvForm.querySelector('#candidates-cv-file');
    const cvUploadField = cvForm.querySelector('[data-cv-upload-field]');
    const cvHelper = cvForm.querySelector('#candidates-cv-formats');
    const requiredReasons = (cvForm.dataset.cvRequiredReasons || '')
      .split('|')
      .map((item) => item.trim())
      .filter(Boolean);

    const updateCvRequiredState = () => {
      const isRequired = requiredReasons.includes(reasonSelect?.value || '');

      cvHiddenInput?.toggleAttribute('required', isRequired);
      cvFileInput?.toggleAttribute('required', isRequired);
      cvUploadField?.classList.toggle('is-required', isRequired);
      cvUploadField?.setAttribute('aria-required', isRequired ? 'true' : 'false');

      if (cvHelper) {
        cvHelper.innerHTML = isRequired
          ? 'CV required for this enquiry.<br>Accepted formats: PDF, DOC, DOCX, RTF, TXT. Max 5MB.'
          : 'CV optional for this enquiry.<br>Accepted formats: PDF, DOC, DOCX, RTF, TXT. Max 5MB.';
      }
    };

    if (reasonSelect && requiredReasons.length) {
      updateCvRequiredState();
      reasonSelect.addEventListener('change', updateCvRequiredState);
    }
  }
}
